import serverVars from 'server-vars';

const isFidReportingDisabled = serverVars.get('enablers.disableFIDReporting');

// Know when the entry types we would like to use are not supported.
function isSupportedPerfEntryType(entryTypes: string[]): boolean {
    for (const entryType of entryTypes) {
        if (!window.PerformanceObserver.supportedEntryTypes.includes(entryType)) {
            return false;
        }
    }
    return true;
}

function msToNs(duration: number): number {
    // datadog stores duration in ns and PerformanceEntry gives use ms.
    // to stay consistent we will convert duration to ns.
    return +(duration * 1e6).toFixed(0);
}

export function initCustomPerformanceReporting(): void {
    if (
        isFidReportingDisabled ||
        !window.DD_RUM ||
        !window.PerformanceObserver ||
        !window.PerformanceObserver.supportedEntryTypes ||
        !isSupportedPerfEntryType(['first-input'])
    ) {
        return;
    }

    const observer = new PerformanceObserver(list => {
        for (const entry of list.getEntries()) {
            // @ts-ignore processingStart on PerformanceEntryList is not in official spec yet.
            const duration = entry.processingStart - entry.startTime;
            window.DD_RUM.addUserAction('First Input Delay', {
                duration: msToNs(duration),
            });
            // after getting 'first-input' entry, we can safely disconnect observer
            observer.disconnect();
        }
    });

    observer.observe({
        type: 'first-input',
        buffered: true,
    });
}
